export default {
  SET_ACTIVE_INTEGRATION(state, value) {
    state.activeIntegrations = value;
  },
};
